export var CacheTime;
(function (CacheTime) {
    CacheTime[CacheTime["None"] = 0] = "None";
    CacheTime[CacheTime["OneMinute"] = 60] = "OneMinute";
    CacheTime[CacheTime["TwoMinutes"] = 120] = "TwoMinutes";
    CacheTime[CacheTime["ThreeMinutes"] = 180] = "ThreeMinutes";
    CacheTime[CacheTime["FiveMinutes"] = 300] = "FiveMinutes";
    CacheTime[CacheTime["Forever"] = Number.MAX_VALUE] = "Forever";
})(CacheTime || (CacheTime = {}));
//# sourceMappingURL=cacheTime.js.map